import {
  Descriptions,
  Divider,
  Input,
  Modal,
  Table,
  TableColumnsType,
  Typography,
} from "antd";
import React, { useState } from "react";

import { useExportWarehouse } from "../../../query/WarehouseQuery";
import { notify } from "../../../utils/toast";
import {
  IPartNumberDtoResponse,
  IWarehouseExport,
} from "../../../models/Warehouse";

interface ModalPreviewExportProps {
  open: boolean;
  selectedItems: Array<IPartNumberDtoResponse & { exportQuantity: number }>;
  onOk: () => void;
  onCancel: () => void;
}
interface DataType extends IPartNumberDtoResponse {
  exportQuantity: number;
}
const ModalPreviewExport: React.FC<ModalPreviewExportProps> = ({
  open,
  selectedItems,
  onOk,
  onCancel,
}) => {
  const [note, setNote] = useState<string>("");
  // const [pdfPreview, setPdfPreview] = useState<string>("");
  // const [showPdfPreview, setShowPdfPreview] = useState(false);
  const exportMutation = useExportWarehouse();
  const totalQuantity = selectedItems.reduce(
    (sum, item) => sum + (item.exportQuantity || 0),
    0,
  );

  const columns: TableColumnsType<DataType> = [
    {
      title: "STT",
      dataIndex: "index",
      align: "center",
      render: (_: any, __: any, index: number) => index + 1,
    },
    {
      title: "Dự án",
      dataIndex: "project",
      align: "center",
    },
    {
      title: "Mã dự án",
      dataIndex: "projectCode",
      align: "center",
    },
    {
      title: "Mã hàng",
      dataIndex: "partNumber",
      align: "center",
    },
    {
      title: "Số lượng xuất",
      dataIndex: "exportQuantity",
      align: "center",
      render: (value: number) => (
        <span className="font-medium text-blue-600">{value}</span>
      ),
    },
    {
      title: "AWB",
      dataIndex: "awb",
      align: "center",
    },
    {
      title: "Kho",
      dataIndex: ["location", "warehouse", "warehouseCode"],
      align: "center",
    },
    {
      title: "Vị trí",
      dataIndex: ["location", "code"],
      align: "center",
    },
    {
      title: "Đơn vị",
      dataIndex: "unit",
      align: "center",
      render: (value: string) => {
        return (
          <span className="text-gray-400">
            {value === "pcs" || value === "PCS"
              ? "Cái"
              : value === "set"
                ? "Bộ"
                : value}
          </span>
        );
      },
    },
  ];
  const handleOk = async (
    selectedItems: Array<IPartNumberDtoResponse & { exportQuantity: number }>,
  ) => {
    const exportData = selectedItems.map((item) => ({
      partNumberId: item.id,
      exportQuantity: item.exportQuantity,
    }));
    const data: IWarehouseExport = {
      exports: exportData,
      note: note,
      projectCode: selectedItems[0]?.projectCode || "",
    };
    try {
      const response = await exportMutation.mutateAsync(data);
      // const pdfUrl = response.pdfBase64;
      const downloadExcel = response.fileUrl;
      if (downloadExcel) {
        window.open(downloadExcel);
      }
      // if (pdfUrl) {
      //   setPdfPreview(pdfUrl);
      //   setShowPdfPreview(true);
      // }
      notify.success("Xuất kho thành công");
      onOk();
    } catch (error) {
      notify.error("Xuất kho thất bại");
    }
  };

  return (
    <>
      <Modal
        open={open}
        title={
          <div className="flex items-center gap-2">
            <Typography.Title
              level={4}
              style={{
                margin: 0,
                fontFamily: "Chakra Petch",
                textTransform: "uppercase",
              }}
            >
              thông tin xuất kho
            </Typography.Title>
            <Typography.Text className="text-gray-600">
              (Kiểm tra kỹ trước khi xác nhận)
            </Typography.Text>
          </div>
        }
        width="70%"
        height={800}
        onOk={() => handleOk(selectedItems)}
        onCancel={onCancel}
        okText="Xác nhận xuất kho"
        cancelText="Đóng"
        centered
        confirmLoading={exportMutation.isPending}
      >
        <div className="space-y-6">
          <Descriptions bordered size="small">
            <Descriptions.Item
              label="Ngày xuất"
              style={{ fontWeight: "bold" }}
              span={3}
            >
              {new Date().toLocaleString("vi-VN", {
                dateStyle: "full",
              })}
            </Descriptions.Item>
          </Descriptions>

          <Divider orientation="left">Chi tiết xuất kho</Divider>
          <Table
            size="small"
            pagination={false}
            columns={columns}
            dataSource={selectedItems}
            rowKey="id"
            bordered
            style={{
              border: "1px solid ",
              borderRadius: 8,
              overflow: "hidden",
            }}
            className="[&_.ant-table-cell]:!border-gray-500"
            summary={() => (
              <Table.Summary fixed="bottom">
                <Table.Summary.Row style={{ fontWeight: "bold" }}>
                  <Table.Summary.Cell index={0} colSpan={4} align="right">
                    <strong>Tổng cộng:</strong>
                  </Table.Summary.Cell>
                  <Table.Summary.Cell index={1} align="center">
                    <span className="font-medium text-blue-600">
                      {totalQuantity}
                    </span>
                  </Table.Summary.Cell>
                  <Table.Summary.Cell index={3} />
                </Table.Summary.Row>
              </Table.Summary>
            )}
          />
          <Input.TextArea
            rows={3}
            placeholder="Ghi chú (nếu có)"
            value={note}
            onChange={(e) => setNote(e.target.value)}
          />
        </div>
      </Modal>
      {/* <ModalPdfPreview
        open={showPdfPreview}
        onCancel={() => setShowPdfPreview(false)}
        pdfBase64={pdfPreview}
      /> */}
    </>
  );
};

export default ModalPreviewExport;
